import type React from 'react';

export type LabelVariant = 'default' | 'error' | 'success';
export type LabelSize = 'sm' | 'md' | 'lg';

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  variant?: LabelVariant;
  size?: LabelSize;
  required?: boolean;
  children: React.ReactNode;
}

const Label: React.FC<LabelProps> = ({
  variant = 'default',
  size = 'md',
  required = false,
  className = '',
  children,
  ...props
}) => {
  // Size classes
  const sizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base'
  };

  // Variant classes
  const variantClasses = {
    default: 'text-text-on-surface',
    error: 'text-danger',
    success: 'text-success'
  };

  const baseClasses = [
    'block',
    'font-medium',
    'font-manrope',
    'leading-normal'
  ];

  const classes = [
    ...baseClasses,
    sizeClasses[size],
    variantClasses[variant],
    className
  ].filter(Boolean).join(' ');

  return (
    <label className={classes} {...props}>
      {children}
      {required && (
        <span className="text-danger ml-1" aria-label="required">
          *
        </span>
      )}
    </label>
  );
};

Label.displayName = 'Label';

export default Label;